import { useState } from "react";
import { toast } from "sonner";
import { sendContact, trackEvent } from "@/lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const EMPTY = { name: "", email: "", message: "", company: "" };

export function validateContact(form) {
  const e = {};
  if (!form.name.trim()) e.name = "Please enter your name.";
  if (!form.email.trim()) e.email = "Please enter your email.";
  else if (!EMAIL_RE.test(form.email.trim()))
    e.email = "Enter a valid email address.";
  if (!form.message.trim()) e.message = "Please enter a message.";
  return e;
}

export function useContactForm() {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const update = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));
  const reset = () => setSubmitted(false);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    const nextErrors = validateContact(form);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;
    if (form.company.trim()) {
      trackEvent("contact_honeypot_blocked");
      setSubmitted(true);
      setForm(EMPTY);
      setErrors({});
      return;
    }

    setSubmitting(true);
    try {
      await sendContact({
        name: form.name.trim(),
        email: form.email.trim(),
        message: form.message.trim(),
      });
      setSubmitted(true);
      setForm(EMPTY);
      setErrors({});
      trackEvent("contact_submit");
      toast.success("Message sent", {
        description: "Thanks — we’ll get back to you by email.",
      });
    } catch (err) {
      toast.error("Could not send message", {
        description: "Please try again, or email us directly.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return { form, errors, submitting, submitted, update, onSubmit, reset };
}
